import { SvgIcon, SvgIconProps } from '@mui/material'

export function PageTemplateIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.833 1.333a.5.5 0 0 1 .5-.5h6.334a.5.5 0 0 1 .5.5v7.333a.5.5 0 0 1-.5.5H1.333a.5.5 0 0 1-.5-.5V1.333Zm1 .5v6.333h5.334V1.833H1.833Zm-1 9.5a.5.5 0 0 1 .5-.5h13.334a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H1.333a.5.5 0 0 1-.5-.5v-3Zm1 .5v2h12.334v-2H1.833Zm8-10.5a.5.5 0 0 1 .5-.5h4.334a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.5.5h-4.334a.5.5 0 0 1-.5-.5V1.333Zm1 .5V3.5h3.334V1.833h-3.334ZM9.833 6a.5.5 0 0 1 .5-.5h4.334a.5.5 0 0 1 .5.5v2.667a.5.5 0 0 1-.5.5h-4.334a.5.5 0 0 1-.5-.5V6Zm1 .5v1.667h3.334V6.5h-3.334Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default PageTemplateIcon
